// Overrides each option's tooltip with a code-specific one when provided
// (e.g. the long Issue Type help copy replacing the short lookup
// description), falling back to the option's existing tooltip otherwise.
export const applyTooltipOverrides = (options, tooltipByCode) => {
  if (!tooltipByCode) {
    return options;
  }

  return options.map(option => ({
    ...option,
    tooltip: tooltipByCode[option.value] ?? option.tooltip,
  }));
};

// Lookups arrive in workflow order; some schemas opt in to alphabetical
// order where that reads better (e.g. the search Status filter).
export const sortOptionsByLabel = options =>
  [...options].sort((a, b) => a.label.localeCompare(b.label));
